import source from '../../../../docs/MAX/src/consts/currencies.json'

import { SelectionOption } from '../core/types/chat.types'

const currencies = source as SelectionOption[]

export default currencies
